module.exports = __webpack_public_path__ + "static/media/typicons.95aa28e2.woff";